import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { DropdownWithSearch } from "hesus-ui-kit";
import { invoiceStatusOptions } from "@utils/constants";
import {
  HeaderGridRow,
  GridItem,
  GridItemOuter,
  SortIconOuter,
} from "../../InvoiceList.styled";
import "../../InvoiceList.scss";
import SearchBox from "@shared/baseUI/SearchBox/SearchBox";

const Header = (props) => {
  const { t, inputFilters, handleSort, sort, handleColumnSearch, entityType } =
    props;

  const getSortIcon = (field) => {
    if (sort.field !== field) {
      return " ↕";
    }
    if (sort.direction === "asc") {
      return " ▲";
    }
    if (sort.direction === "desc") {
      return " ▼";
    }
    return " ↕";
  };

  return (
    <HeaderGridRow
      column={
        ["company", "site"].includes(entityType)
          ? "13.5% 13.5% 11.5% 11.5% 11.5% 15.5% 11.5% 11.5%"
          : "12% 12% 12% 10% 10% 10% 14% 10% 10%"
      }
      marginBottom="0px"
      gridGap="0rem"
      marginTop="0px"
    >
      <GridItem
        padding="8px"
        fontWeight="700"
        radius="5px 0px 0px 0px"
        borderRight="1px solid #fff"
        borderLeft="2px solid #767676"
      >
        <GridItemOuter
          onClick={() => handleSort("client_invoice.document_number")}
        >
          {t("CLIENT_INVOICING_DOCUMENT_NUMBER")}
          <SortIconOuter>
            {getSortIcon("client_invoice.document_number")}
          </SortIconOuter>
        </GridItemOuter>
        <SearchBox
          value={inputFilters.document || ""}
          name="document-filter"
          inputClassName="invoice-list__search-style"
          onChange={(e) => handleColumnSearch("document", e.target.value)}
        />
      </GridItem>
      {entityType !== "company" && (
        <GridItem
          padding="8px"
          fontWeight="700"
          borderRight="1px solid #fff"
          textAlign="left"
        >
          <GridItemOuter
            onClick={() => handleSort("company.name")}
            justifyContent="flex-start"
          >
            {t("CLIENT_INVOICING_CLIENT")}
            <SortIconOuter>{getSortIcon("company.name")}</SortIconOuter>
          </GridItemOuter>
          <SearchBox
            value={inputFilters.client || ""}
            name="document-filter"
            inputClassName="invoice-list__search-style"
            onChange={(e) => handleColumnSearch("client", e.target.value)}
          />
        </GridItem>
      )}
      {entityType !== "site" && (
        <GridItem
          padding="8px"
          fontWeight="700"
          borderRight="1px solid #fff"
          textAlign="left"
        >
          <GridItemOuter
            onClick={() => handleSort("jobsite.name")}
            justifyContent="flex-start"
          >
            {t("CLIENT_INVOICING_SITE")}
            <SortIconOuter>{getSortIcon("jobsite.name")}</SortIconOuter>
          </GridItemOuter>
          <SearchBox
            value={inputFilters.site || ""}
            name="document-filter"
            inputClassName="invoice-list__search-style"
            onChange={(e) => handleColumnSearch("site", e.target.value)}
          />
        </GridItem>
      )}
      <GridItem
        padding="8px"
        fontWeight="700"
        borderRight="1px solid #fff"
        alignContent="center"
        justifyContent="space-around"
      >
        <GridItemOuter
          onClick={() => handleSort("client_invoice.invoice_date")}
        >
          {t("CLIENT_INVOICING_DATE")}
          <SortIconOuter>
            {getSortIcon("client_invoice.invoice_date")}
          </SortIconOuter>
        </GridItemOuter>
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        borderRight="1px solid #fff"
        justifyContent="space-around"
      >
        <GridItemOuter onClick={() => handleSort("client_invoice.due_date")}>
          {t("CLIENT_INVOICING_DUE_DATE")}
          <SortIconOuter>
            {getSortIcon("client_invoice.due_date")}
          </SortIconOuter>
        </GridItemOuter>
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        borderRight="1px solid #fff"
        justifyContent="space-around"
      >
        {t("CLIENT_INVOICING_TOTAL_EXCLUDED_TAXES")}
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        borderRight="1px solid #fff"
        justifyContent="space-around"
      >
        {t("CLIENT_INVOICING_LEFT_TO_PAY")}
      </GridItem>
      <GridItem padding="8px" fontWeight="700" borderRight="1px solid #fff">
        <GridItemOuter onClick={() => handleSort("client_invoice.status_id")}>
          {t("CLIENT_INVOICING_STATUS")}
          <SortIconOuter>
            {getSortIcon("client_invoice.status_id")}
          </SortIconOuter>
        </GridItemOuter>
        <DropdownWithSearch
          id="invoice-status"
          label=""
          name="status"
          value={inputFilters.status}
          isMulti
          onChange={(status) => handleColumnSearch("status", status)}
          defaultOption={t("CLIENT_INVOICING_STATUS_ANY")}
          options={invoiceStatusOptions(t)}
          labelStyles={{ display: "none" }}
        />
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        radius="0px 5px 0px 0px"
        justifyContent="space-around"
      >
        {t("CLIENT_INVOICING_ACTIONS")}
      </GridItem>
    </HeaderGridRow>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

Header.defaultProps = {
  page: "main",
};

export default withTranslation()(Header);
